/**
 * DOTTHZ announcement bar — fade slider
 * Editable via Theme Editor message blocks.
 */
(function () {
  function init(scope) {
    const roots = (scope || document).querySelectorAll("[data-dotthz-announce]");
    roots.forEach((root) => {
      if (root.dataset.ready === "1") return;

      const slides = Array.from(root.querySelectorAll("[data-announce-slide]"));
      if (!slides.length) return;

      root.dataset.ready = "1";

      const autoplay = root.getAttribute("data-autoplay") === "true";
      const speed = Math.max(2000, Number(root.getAttribute("data-speed") || 4000));
      const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      let index = slides.findIndex((s) => s.classList.contains("is-active"));
      if (index < 0) index = 0;

      const show = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((slide, n) => {
          const on = n === index;
          slide.classList.toggle("is-active", on);
          slide.setAttribute("aria-hidden", on ? "false" : "true");
        });
      };

      show(index);

      const prevBtn = root.querySelector("[data-announce-prev]");
      const nextBtn = root.querySelector("[data-announce-next]");
      if (prevBtn) prevBtn.addEventListener("click", () => show(index - 1));
      if (nextBtn) nextBtn.addEventListener("click", () => show(index + 1));

      if (!autoplay || slides.length < 2 || prefersReduced) return;

      let timer = setInterval(() => show(index + 1), speed);

      root.addEventListener("mouseenter", () => clearInterval(timer));
      root.addEventListener("mouseleave", () => {
        clearInterval(timer);
        timer = setInterval(() => show(index + 1), speed);
      });
    });
  }

  const boot = () => init(document);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const target = event.target;
    if (!target) return;
    target.querySelectorAll?.("[data-dotthz-announce]").forEach((el) => {
      delete el.dataset.ready;
    });
    if (target.matches?.("[data-dotthz-announce]")) delete target.dataset.ready;
    init(target);
  });
})();
